import axios from 'axios'


const MeetingService = {
    postMeetingRequest : (meetingRequest) =>{
        return axios.post("https://app-ymyksqua4a-uc.a.run.app/api/meeting-request", meetingRequest)
    }
}

export default MeetingService